import React from "react";
import { useClaims } from "../../../auth/ClaimsProvider";
import CustomerExperienceTwoColumnDashboard from "../../../v2/src/dashboards/CustomerExperienceTwoColumnDashboard";

const UnifiedHomeDashboard = () => {
  const { isGuestUser, getClaimValue } = useClaims();
  const firstName = getClaimValue("firstName");
  const welcomeMessage = !!firstName ? `Welcome to SHI One, ${firstName}` : "Welcome to SHI One";
  
  if (isGuestUser()) {
    return (
      <CustomerExperienceTwoColumnDashboard
        dashboardId={"guest-user-home-dashboard"}
      />
    );
  }

  return (
    <CustomerExperienceTwoColumnDashboard
      dashboardId={"customer-experience-unified-home-dashboard"}
      header={welcomeMessage}
      subheader="Shop for products, manage orders, view insightful reports, and plan your roadmaps, all in one place"
      dialogTitle="Home Dashboard"
    />
  );
};

export default UnifiedHomeDashboard;
